import { defineEvent } from "../types/event";
export var FILTER_OPTION_SELECT = defineEvent({
    platforms: [
        {
            name: "Optimizely",
            alias: "Filter_option_selected"
        }
    ]
});
